import { ProductListComponent } from './product-list/product-list.component';
export var productRoutes = [
    {
        path: 'product',
        data: {
            'expectedRoles': ['Admin', 'Accountant', 'Accountant Admin']
        },
        children: [
            {
                path: 'list',
                component: ProductListComponent,
                data: {
                    'expectedRoles': ['Admin', 'Accountant', 'Accountant Admin']
                },
            },
            {
                path: 'manage',
                component: ProductListComponent,
                data: {
                    'expectedRoles': ['Admin', 'Accountant', 'Accountant Admin']
                },
            }
        ],
    }
];
var ProductRoutingModule = (function () {
    function ProductRoutingModule() {
    }
    return ProductRoutingModule;
}());
export { ProductRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/product/product-routing.module.ts.pre-build-optimizer.js